import React, { Component } from 'react';
import { Layout, Spin, Button, Icon, message } from "antd";

import * as authService from '../services/authService';

const { Content, Header } = Layout;

export default class Account extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = { api: null, copied: false };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadApi();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleLogout = async () => {
    await authService.logout();
    if (this.props.onLogout) {
      this.props.onLogout();
    }
  };

  copyApiKey = () => {
    const { api } = this.state;
    if (api && api.api) {
      navigator.clipboard.writeText(api.api);
      message.success('API key copied to clipboard');
      this.setState({ copied: true });
      setTimeout(() => this.setState({ copied: false }), 2000);
    }
  };

  loadApi = () => {
    const { user } = this.props;
    if (!user) return;

    fetch("https://api.elfdigest.com:2083/apikey/" + user.email, {
      method: 'get',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
      .then(res => res.json())
      .then(api => {
        if (this._isMounted && !api.hasOwnProperty("error")) {
          this.setState({ api });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    const { user } = this.props;
    const { api, copied } = this.state;

    if (!api) {
      return (
        <div className="report-missing" style={{ marginLeft: 200 }}>
          <Spin size="large" />
          <p>Loading account information...</p>
        </div>
      );
    }

    return (
      <Layout style={{ marginLeft: 200 }}>
        <Header className="header">
          <h2 className="header-headline">Account</h2>
        </Header>
        <Content className="page-content">
          <div className="inner-page-content">
            {/* User Profile Card */}
            <div style={{
              background: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
              borderRadius: 16,
              padding: '32px',
              marginBottom: 24,
              color: '#fff',
              boxShadow: '0 10px 40px rgba(139, 92, 246, 0.3)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{
                  width: 64,
                  height: 64,
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 20,
                }}>
                  <Icon type="user" style={{ fontSize: 28, color: '#fff' }} />
                </div>
                <div>
                  <h3 style={{ margin: 0, color: '#fff', fontSize: 20 }}>
                    Welcome back!
                  </h3>
                  <p style={{ margin: '4px 0 0', opacity: 0.9, fontSize: 15 }}>
                    {user && user.email}
                  </p>
                </div>
              </div>
            </div>

            {/* API Key Card */}
            <div style={{
              background: '#fff',
              borderRadius: 12,
              padding: '24px',
              marginBottom: 24,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <Icon type="key" style={{ fontSize: 20, color: '#8b5cf6', marginRight: 12 }} />
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>API Key</h3>
              </div>
              <p style={{ color: '#64748b', marginBottom: 16, fontSize: 14 }}>
                Use this key to authenticate API requests. Keep it secure and never share it publicly.
              </p>
              <div style={{
                background: '#f8fafc',
                borderRadius: 8,
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: '1px solid #e2e8f0',
              }}>
                <code style={{
                  background: 'transparent',
                  padding: 0,
                  fontSize: 13,
                  color: '#1e293b',
                  wordBreak: 'break-all',
                  flex: 1,
                  marginRight: 12,
                }}>
                  {api.api}
                </code>
                <Button
                  type={copied ? "primary" : "default"}
                  icon={copied ? "check" : "copy"}
                  onClick={this.copyApiKey}
                  style={{ flexShrink: 0 }}
                >
                  {copied ? 'Copied!' : 'Copy'}
                </Button>
              </div>
            </div>

            {/* Quick Links Card */}
            <div style={{
              background: '#fff',
              borderRadius: 12,
              padding: '24px',
              marginBottom: 24,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <Icon type="link" style={{ fontSize: 20, color: '#8b5cf6', marginRight: 12 }} />
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Quick Links</h3>
              </div>
              <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                <Button icon="cloud-upload" href="#/submit">Submit Sample</Button>
                <Button icon="file-text" href="#/myreports">My Reports</Button>
                <Button icon="global" href="#/results">Public Reports</Button>
              </div>
            </div>

            {/* Logout Card */}
            <div style={{
              background: '#fff',
              borderRadius: 12,
              padding: '24px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                <Icon type="logout" style={{ fontSize: 20, color: '#ef4444', marginRight: 12 }} />
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Session</h3>
              </div>
              <p style={{ color: '#64748b', marginBottom: 16, fontSize: 14 }}>
                Sign out of your account. You'll need to sign in again to access protected pages.
              </p>
              <Button
                type="danger"
                icon="logout"
                onClick={this.handleLogout}
              >
                Sign Out
              </Button>
            </div>
          </div>
        </Content>
      </Layout>
    );
  }
}
